import LetterAvatar from "@/components/Avatar/LetterAvatar"
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined"
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined"
import { Box, Link } from "@mui/material"

export const columns = [
  {
    header: "Code",
    accessorKey: "code",
  },
  {
    header: "Supplier",
    cell: ({ row }) => (
      <LetterAvatar
        name={row.original.name}
        subtitle={`${row.original.address}`}
      />
    ),
  },
  {
    header: "Contact Person",
    cell: ({ row }) => (
      <LetterAvatar
        name={row.original.contact_person}
        subtitle={
          <Box display="flex" alignItems="flex-end">
            <Box display="flex" alignItems="center">
              <LocalPhoneOutlinedIcon fontSize="small" />
              &nbsp;
              <Link href={`tel:${row.original.phone}`} underline="none">
                {row.original.phone}
              </Link>
            </Box>
            {row.original.email ? (
              <>
                &nbsp;&nbsp;&nbsp;
                <Box display="flex" alignItems="center">
                  <EmailOutlinedIcon fontSize="small" />
                  &nbsp;
                  <Link href={`mailto:${row.original.email}`} underline="none">
                    {row.original.email}
                  </Link>
                </Box>
              </>
            ) : null}
          </Box>
        }
      />
    ),
  },
  {
    header: "PAN Number",
    accessorKey: "pan_number",
  },
]
